import { render } from "./CardItem.vue?vue&type=template&id=bbf23bba&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"

import "./CardItem.vue?vue&type=style&index=0&id=bbf23bba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenovo\\OneDrive\\Documents\\Freelance\\symphinite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf23bba"]])

export default __exports__